import React from 'react';
import { css } from 'emotion';
const fullWidthStyles = css `
	width: 100%;
`;
/**
 * Note the iframe created in this component is dependent on the embedIFrame function being
 * called to be size correctly.
 * src/web/browser/embedIframe/embedIframe.ts
 */
export const InstagramBlockComponent = ({ element, index }) => {
    return (React.createElement("iframe", { className: `${fullWidthStyles} js-embed__iframe`, name: `instagram-embed-${index}`, "data-cy": "instagram-embed", title: `Instagram Post ${index}`, srcDoc: `${element.html}
			<script src="https://interactive.guim.co.uk/libs/iframe-messenger/iframeMessenger.js"></script>
			<gu-script>iframeMessenger.enableAutoResize();</gu-script>` }));
};
